import { BiClipboard, BiHistory, BiLayer } from 'react-icons/bi';
import { abrirOPatrimonio } from './patrimonio';

export const historicoDoPatrimonio = {
  id: 'historico-do-patrimonio',
  titulo: 'Histórico de um patrimônio',
  descricao: 'Quem moveu, quando e para onde. Use quando o cliente diz que não recebeu.',
  icone: BiHistory,
  passos: [
    abrirOPatrimonio,
    {
      alvo: 'aba:Histórico Patrimônio',
      titulo: 'Histórico Patrimônio',
      texto: 'Clique na aba Histórico Patrimônio.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'historico:etiqueta',
      titulo: 'Número da etiqueta',
      texto: 'Digite o número da etiqueta do patrimônio.',
      lado: 'bottom',
      avancaAoDigitar: true,
    },
    {
      alvo: 'historico:enviar',
      titulo: 'Enviar',
      texto: 'Clique em Enviar para buscar as movimentações dessa etiqueta.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'tabela:primeira-linha',
      titulo: 'Movimentações',
      texto:
        'Cada linha é uma movimentação: a data e o cliente e o anexo para onde o patrimônio foi. Na auditoria, é aqui que se procura um item que falta.',
      lado: 'bottom',
      paciencia: 15000,
      pulaSeAusente: true,
    },
  ],
};

export const marcaModeloEGrupos = {
  id: 'marca-modelo-e-grupos',
  titulo: 'Marca, modelo e grupos',
  descricao: 'Cadastre modelo novo sem duplicar e monte kits, como base DECT com handsets.',
  icone: BiLayer,
  exigeAdmin: true,
  passos: [
    abrirOPatrimonio,
    {
      alvo: 'aba:Marca/Modelo',
      titulo: 'Marca/Modelo',
      texto: 'Clique em Marca/Modelo.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'marca-modelo:fornecedor',
      titulo: 'Fornecedor',
      texto:
        'Escolha o fornecedor para ver as marcas e os modelos dele. Procure antes de criar: o mesmo modelo escrito de várias formas bagunça o estoque.',
      lado: 'bottom',
    },
    {
      alvo: 'aba:Grupos',
      titulo: 'Grupos',
      texto: 'Clique em Grupos.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'grupos:novo',
      titulo: 'Novo Grupo',
      texto:
        'Kits como base DECT com handsets ou ATA viram um grupo e saem juntos. Veja se o grupo já existe na lista antes de criar outro.',
      lado: 'left',
      paciencia: 10000,
    },
    {
      alvo: 'tabela:pesquisar',
      titulo: 'Procure o grupo',
      texto: 'Pesquise pelo nome para ver, editar ou excluir um grupo.',
      lado: 'bottom',
    },
  ],
};

export const auditoriaMensal = {
  id: 'auditoria-mensal',
  titulo: 'Auditoria mensal do estoque',
  descricao: 'Exporte o patrimônio da VOXCITY TECNOLOGIA e compare com a contagem física.',
  icone: BiClipboard,
  passos: [
    {
      alvo: 'menu:Relatórios',
      titulo: 'Relatórios',
      texto: 'Clique em Relatórios.',
      lado: 'right',
      exigeClique: true,
    },
    {
      alvo: 'aba:Patrimônio por cliente',
      titulo: 'Patrimônio por cliente',
      texto: 'Lista tudo o que está num cliente, com Gerar PDF e Gerar XLS no fim da tabela.',
      lado: 'bottom',
    },
    {
      alvo: 'relatorio:cliente',
      titulo: 'Escolha o cliente',
      texto: 'Para a auditoria do estoque, escolha VOXCITY TECNOLOGIA e exporte o XLS.',
      fala: 'Para a auditoria do estoque, escolha Vox City Tecnologia e exporte a planilha.',
      lado: 'bottom',
    },
    {
      alvo: 'relatorio:cliente',
      titulo: 'Compare com o físico',
      texto:
        'Conte o estoque e marque cada linha: OK, falta, sobra ou defeito. Sobra: cadastre. Falta: veja o Histórico Patrimônio. Defeito: movimente para o anexo de defeito. Envie o resultado ao coordenador de Projetos.',
      lado: 'bottom',
    },
    {
      alvo: 'aba:Status da instalação',
      titulo: 'Status da instalação',
      texto: 'Mostra o que já foi instalado em cada cliente.',
      lado: 'bottom',
    },
  ],
};
